import { atomWithReset } from "jotai/utils";

export const showStepSummaryButtonAtom = atomWithReset<boolean | null>(false);
